<template>
  <div class="section agriculture">
    <div class="activity-title-row">
      <h1 class="activity-title">Agriculture</h1>
      <i class="title-icon fad fa-tractor"></i>
    </div>

      <!-- v-bind:initialSchema="schema" -->
    <AgricultureComponent
      v-bind:initialSchema="
        schema[this.getSchemaIndex('Livestock')]
      "
      schemaName="Livestock"
      @calculateTotal="calculateTotal"
      :activityID="$options.name"
    />
    <Notes
      :key="1"
      :schemaIndex="0"
      :dataSource="schema[0].dataSource"
      @dataSourceChanged="updateDataSource"
      :dataQuality="schema[0].dataQuality"
      @dataQualityChanged="updateDataQuality"
      :assumptions="schema[0].assumptions"
      @assumptionsChanged="updateAssumptions"
    />
    <div class="spacer"></div>
    <FertiliserComponent
      v-if="schema.length > 1"
      v-bind:initialSchema="
        schema[this.getSchemaIndex('Fertiliser Use')]
      "
      schemaName="Fertiliser Use"
      @calculateTotal="calculateTotal"
      :activityID="$options.name"
    />
    <Notes
      v-if="schema.length > 1"
      :key="2"
      :schemaIndex="1"
      :dataSource="schema[1].dataSource"
      @dataSourceChanged="updateDataSource"
      :dataQuality="schema[1].dataQuality"
      @dataQualityChanged="updateDataQuality"
      :assumptions="schema[1].assumptions"
      @assumptionsChanged="updateAssumptions"
    />
  </div>
</template>

<script>
import Notes from '../../../Notes.vue'
import AgricultureComponent from './AgricultureComponent'
import FertiliserComponent from './FertiliserComponent'

export default {
  metaData () {
    return {
      title: `dCarbon — Agriculture`,
      description: ''
    }
  },
  name: 'activity-agriculture',
  props: {
    initialSchema: Object,
    scope: String
  },
  components: { AgricultureComponent, FertiliserComponent, Notes },
  data () {
    return {
      schema: {}
    }
  },
  beforeMount () {
    this.schema = this.$root.getSchema(this.scope)
  },
  methods: {
    updateDataSource (value) {
      this.schema[value.schemaIndex].dataSource = value.val
    },
    updateDataQuality (value) {
      this.schema[value.schemaIndex].dataQuality = value.val
    },
    updateAssumptions (value) {
      this.schema[value.schemaIndex].assumptions = value.val
    },
    calculateTotal (schema, schemaName) {
      let schemaIndex = this.getSchemaIndex(schemaName)
      this.schema[schemaIndex] = schema
      this.$root.updateMasterSchema(this.schema, this.scope)
    },
    getSchemaIndex (name) {
      return this.schema.findIndex(s => s.name === name)
    }
  }
}
</script>
